
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductoPage = lazy(() => import('../pages/producto/page'));
const ProductoDirectoPage = lazy(() => import('../pages/producto-directo/page'));
const CarritoPage = lazy(() => import('../pages/carrito/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const PedidoConfirmadoPage = lazy(() => import('../pages/pedido-confirmado/page'));
const PedidosPage = lazy(() => import('../pages/pedidos/page'));
const PerfilPage = lazy(() => import('../pages/perfil/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const RegistroPage = lazy(() => import('../pages/registro/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/producto',
    element: <ProductoPage />,
  },
  {
    path: '/producto-directo',
    element: <ProductoDirectoPage />,
  },
  {
    path: '/contacto',
    element: <ContactoPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/registro',
    element: <RegistroPage />,
  },
  {
    path: '/carrito',
    element: <CarritoPage />,
  },
  {
    path: '/perfil',
    element: <PerfilPage />,
  },
  {
    path: '/pedidos',
    element: <PedidosPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/pedido-confirmado',
    element: <PedidoConfirmadoPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
